import { render } from "./VendorPreviewContent.vue?vue&type=template&id=7972372f&scoped=true"
import script from "./VendorPreviewContent.vue?vue&type=script&lang=js"
export * from "./VendorPreviewContent.vue?vue&type=script&lang=js"

import "./VendorPreviewContent.vue?vue&type=style&index=0&id=7972372f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7972372f"]])

export default __exports__